import styles from '../ParamsTable.module.css';
import { TableSkeleton } from '../TableSkeleton';
import type { DependentParam, TextureSoil } from '../../../types/parameters.types';
import { getClassesForTexture } from '../../../utils/paramsTableUtils';
import { useMacroParamsEdit } from '../../../hooks/useMacroParamsEdit';

interface MacroParamsTableProps {
	params: DependentParam[];
	texture: TextureSoil;
	isLoading: boolean;
	onChange?: (params: DependentParam[]) => void;
}

export const MacroParamsTable = ({
	params,
	texture,
	isLoading,
	onChange,
}: MacroParamsTableProps) => {
	const { editingCode, editValues, startEdit, handleInputChange } = useMacroParamsEdit(
		params,
		texture,
		onChange
	);

	if (isLoading) return <TableSkeleton rows={5} cols={6} />;

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Parâmetro</th>
						<th>Método</th>
						<th>Unidade</th>
						<th>Baixo</th>
						<th>Médio</th>
						<th>Alto</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{params.map((param) => {
						const { low, medium, high } = getClassesForTexture(param, texture);
						const isEditing = editingCode === param.code;

						return (
							<tr key={param.code}>
								<td>
									<span className={styles.paramName}>{param.name}</span>
								</td>
								<td>
									<span className={styles.methodText}>{param.method}</span>
								</td>
								<td>
									<span className={styles.unitText}>{param.unit}</span>
								</td>

								{isEditing ? (
									<>
										<td>
											<input
												autoFocus
												className={styles.editInput}
												value={editValues.low}
												onChange={(e) =>
													handleInputChange(param, 'low', e.target.value)
												}
											/>
										</td>
										<td>
											<input
												className={styles.editInput}
												value={editValues.medium}
												onChange={(e) =>
													handleInputChange(param, 'medium', e.target.value)
												}
											/>
										</td>
										<td>
											<input
												className={styles.editInput}
												value={editValues.high}
												onChange={(e) =>
													handleInputChange(param, 'high', e.target.value)
												}
											/>
										</td>
									</>
								) : (
									<>
										<td>
											<span
												className={`${styles.badge} ${styles.badgeLow}`}
												onClick={() => startEdit(param)}
												role={onChange ? 'button' : undefined}
												tabIndex={onChange ? 0 : undefined}
												onKeyDown={onChange ? (e) => (e.key === 'Enter' || e.key === ' ') && startEdit(param) : undefined}
											>
												{low}
											</span>
										</td>
										<td>
											<span
												className={`${styles.badge} ${styles.badgeMedium}`}
												onClick={() => startEdit(param)}
												role={onChange ? 'button' : undefined}
												tabIndex={onChange ? 0 : undefined}
												onKeyDown={onChange ? (e) => (e.key === 'Enter' || e.key === ' ') && startEdit(param) : undefined}
											>
												{medium}
											</span>
										</td>
										<td>
											<span
												className={`${styles.badge} ${styles.badgeHigh}`}
												onClick={() => startEdit(param)}
												role={onChange ? 'button' : undefined}
												tabIndex={onChange ? 0 : undefined}
												onKeyDown={onChange ? (e) => (e.key === 'Enter' || e.key === ' ') && startEdit(param) : undefined}
											>
												{high}
											</span>
										</td>
									</>
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};
